module.exports = __webpack_public_path__ + "media/Pasabi.d1316c4a.mp3";